"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Click here to expand the group members": "Click here to expand the group members",
  "Click here to view the group members": "Click here to view the group members",
  "Company, {company}": ["Company, ", ["company"]],
  "Contact card, {name}": ["Contact card, ", ["name"]],
  "Department, {department}": ["Department, ", ["department"]],
  "Email, {emailAddress}": ["Email, ", ["emailAddress"]],
  "Expand members": "Expand members",
  "Group - {members, plural, one {# member} other {# members}}": ["Group - ", ["members", "plural", {
    one: ["#", " member"],
    other: ["#", " members"]
  }]],
  "Mobile phone, {mobilePhone}": ["Mobile phone, ", ["mobilePhone"]],
  "Mobile: {mobilePhone}": ["Mobile: ", ["mobilePhone"]],
  "Name, {name}": ["Name, ", ["name"]],
  "Title, {title}": ["Title, ", ["title"]],
  "Type to search": "Type to search",
  "View members": "View members",
  "Work phone, {workPhone}": ["Work phone, ", ["workPhone"]],
  "Work: {workPhone}": ["Work: ", ["workPhone"]]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map